import styled from 'styled-components';

export const ContainerEnergy = styled.div<{ isApp?: boolean }>`
  margin: ${({ isApp }) => (isApp ? 'inherit' : '0 20px 0 20px')};
  height: 100%;
`;
